module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('styled-select-new', {
    ref: "select",
    staticClass: "advertiser-select-new__text_colors",
    attrs: {
      "value": _vm.value,
      "options": _vm.options,
      "disabled": _vm.disabled,
      "searchOptions": _vm.searchOptions,
      "label": "Name"
    },
    on: {
      "input": _vm.emitInput
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0eb2603b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/newSelect/AdvertiserSelectNew.vue
// module id = 1811
// module chunks = 0